import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchOrgScheduleQuestionnairesArgs,
  FetchScheduleQuestionnairesArgs,
} from '../api/types/scheduleQuestionnaire.types';

import {
  fetchOrgScheduleQuestionnaires,
  fetchScheduleQuestionnaires,
} from '../api/scheduleQuestionnaire.api';

export const scheduleQuestionnaireQueryKeys = createQueryKeys(
  'scheduleQuestionnaire',
  {
    fetchOrgScheduleQuestionnaires: ({
      from,
      organizationId,
      to,
    }: FetchOrgScheduleQuestionnairesArgs) => ({
      queryFn: () =>
        fetchOrgScheduleQuestionnaires({ from, organizationId, to }),
      queryKey: [organizationId, from, to],
    }),
    fetchScheduleQuestionnaires: ({
      clientId,
      from,
      organizationId,
      to,
    }: FetchScheduleQuestionnairesArgs) => ({
      queryFn: () =>
        fetchScheduleQuestionnaires({ clientId, from, organizationId, to }),
      queryKey: [organizationId, clientId, from, to],
    }),
  },
);
